/**
 * axios setup to use mock service
 */

import { Auth } from "@aws-amplify/auth";
import axios from "axios";

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
});

axiosServices.interceptors.request.use(
  async (request) => {
    try {
      const connectedUser = await Auth.currentAuthenticatedUser();
      if (connectedUser && connectedUser.signInUserSession) {
        const token = connectedUser.signInUserSession.idToken.jwtToken;
        request.headers.Authorization = `Bearer ${token}`;
      }
      return request;
    } catch (err) {
      return request;
    }
  },
  (error) => Promise.reject(error.response && error.response.data)
);

export default axiosServices;
